import React from 'react';
import { FluidObject } from 'gatsby-image';
import getFluidOrSvg from '../../utils/getFluidOrSvg';
import styled from 'styled-components';

interface Props {
  imgSrc: {
    childImageSharp: {
      fluid: FluidObject;
    };
    extension: string;
    publicURL: string;
  };
  alt: string;
  caption?: string;
}

export default ({ imgSrc, alt, caption }: Props) => {
  return (
    <>
      <Figure>{getFluidOrSvg({ imgSrc, alt })}</Figure>
      {caption && <Caption>{caption}</Caption>}
    </>
  );
};

const Figure = styled.figure`
  border-radius: 16px;
  overflow: hidden;
`;

const Caption = styled.figcaption`
  padding-top: 1.5rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.grey500};
  margin: 0 auto;
  font-size: 0.875rem;
  margin-bottom: 3rem;
`;
